import {TurnkeyCostData} from "../types/tp-turnkey-cost-modal,types";

export const defaultTurnkeyCostData: TurnkeyCostData = {
  id: 0,
  history: [],
  cost: 0,
  date: '',
  comment: ''
}
